import { useMatch } from "react-router";

import { GqlClient } from "~/__generated__";
import useCurrentClient from "~/modules/client/hooks/useCurrentClient";
import { GqlProjectMetadata } from "~/modules/project/api/useMeGetProjectInfoQuery";
import useCurrentProject from "~/modules/project/hooks/useCurrentProject";

export default function useClientOrProjectScope(): {
    client?: GqlClient;
    project?: GqlProjectMetadata;
} {
    const { client } = useCurrentClient() ?? {};
    const { data: projectData } = useCurrentProject();
    const isProjectContext = useMatch("/c/:clientSlug/p/:projectSlug/*");

    return isProjectContext ? { project: projectData?.project } : { client };
}
